import('./src/main');
